module.exports = __webpack_public_path__ + "img/icon-google.ed5d503e.svg";